import {
    defaultModelResult,
    defaultNewCarResult,
} from "../../../shared-logic/features/filters/utils/constants/resultConstants";
import {
    initialStateTradeInAemModelSelect,
    type TradeInAemModelSelectReducerType,
} from "../../redux/reducers/TradeInAemModelSelectReducer";
import { TradeInAemContactFormId, TradeInAemModelSelectType } from "../constants";
import { initialStateTradeInAemVehicleValue } from "../../redux/reducers/TradeInAemVehicleValueReducer";
import type { TradeInAemContactFormReducerType } from "../../redux/reducers/TradeInAemContactFormReducer";
import type {
    TradeInAemFiLicenseApiResponseType,
    TradeInAemFiValueApiResponseType,
} from "../../csl/implementations/standalone/fi";

export const mockModelSelectState: TradeInAemModelSelectReducerType = {
    ...initialStateTradeInAemModelSelect,
    initialized: false,
    enabled: false,
    selectedCarType: TradeInAemModelSelectType.New,
    selectedModelId: "id1",
    modelList: [
        {
            ...defaultModelResult,
            id: "id1",
            name: "name1",
            cars: [defaultNewCarResult],
        },
        {
            ...defaultModelResult,
            id: "id2",
            name: "name2",
            cars: [defaultNewCarResult],
        },
    ],
};

export const mockTradeInAemFindVehicleResponse: TradeInAemFiLicenseApiResponseType = {
    specification: {
        vehicles: [
            {
                typeETGCode: "10070075",
                makeDescription: "BMW",
                modelDescription: "X4 Diesel Maastoauto",
                vehType: "10",
                typeDescription: "X4 F26 xDrive20d A",
                engineSize: 1995,
                enginePS: 190.35,
                engineKW: 140,
                fuelType: "Diesel",
                bodyType: "Maastoauto",
                numberDoors: 5,
                numberGears: 8,
                gearType: "Portaaton automaatti",
                periodOfBuildDetails: { poBFromMonth: 4, poBFromYear: 2016, poBUntilMonth: 8, poBUntilYear: 2018 },
                priceNetto: 47740,
                priceBrutto: 60616.02,
                driveType: "Neliveto",
                trimLine: "Business xLine",
            },
            {
                typeETGCode: "10070071",
                makeDescription: "BMW",
                modelDescription: "X4 Diesel Maastoauto",
                vehType: "10",
                typeDescription: "X4 F26 xDrive20d A",
                engineSize: 1995,
                enginePS: 190.35,
                engineKW: 140,
                fuelType: "Diesel",
                bodyType: "Maastoauto",
                numberDoors: 5,
                numberGears: 8,
                gearType: "Portaaton automaatti",
                periodOfBuildDetails: { poBFromMonth: 7, poBFromYear: 2014, poBUntilMonth: 8, poBUntilYear: 2018 },
                priceNetto: 47250,
                priceBrutto: 59993.14,
                driveType: "Neliveto",
                trimLine: "Business xLine",
            },
        ],
    },
    plate: "BTV-925",
    vin: "WBAXX1109H0T37094",
    plateData: {
        vin: "WBAXX1109H0T37094",
        plate: "BTV-925",
        registrationDate: "20161012",
        hp: 0,
        watt: 0,
        ccm: 0,
        co2Emissions: 0,
        country: "FI",
    },
};

export const mockTradeInAemVehicleValueResponse: TradeInAemFiValueApiResponseType = {
    quote: {
        regionalAskingPrice: 30990,
        regionalSalesPrice: 29170,
        date: "2025-03-26T14:02:05.7489184Z",
        status: "Ok",
        raw: {
            stockDay: 49,
            regionalAskingPrice: 30990,
            regionalSalesPrice: 29170,
            calculatedAt: "2025-03-26T14:02:05.7489184Z",
            statusCode: 0,
            statusMessage: "Ok",
        },
        value: {
            min: 28470,
            rules: ["Repair Costs"],
            detail: [],
            expires: "2025-04-09T14:02:05.784Z",
        },
        id: "S37zeX3H76bgIfh3k_aeO",
    },
    context: {
        country: "fi",
    },
    registrationDate: "202301",
    mileage: 100000,
    bodyType: "Maastoauto",
    engineKW: 140,
    enginePS: 190.35,
    engineSize: 1995,
    fuelType: "Diesel",
    gearType: "Portaaton automaatti",
    makeDescription: "BMW",
    modelDescription: "X4 Diesel Maastoauto",
    numberDoors: 5,
    numberGears: 8,
    periodOfBuildDetails: { poBFromMonth: 7, poBFromYear: 2014, poBUntilMonth: 8, poBUntilYear: 2018 },
    plate: "BTV-925",
    priceBrutto: 59993.14,
    priceNetto: 47250,
    typeDescription: "X4 F26 xDrive20d A",
    typeETGCode: "10070071",
    vehType: "10",
    vin: "WBAXX1109H0T37094",
    firstRegistrationDate: "2016-10-12",
    driveType: "Neliveto",
    trimLine: "Business xLine",
};

export const mockVehicleValueState = {
    ...initialStateTradeInAemVehicleValue,
    valuation: mockTradeInAemVehicleValueResponse,
};

export const mockTradeInContactForm: TradeInAemContactFormReducerType = {
    initialized: true,
    [TradeInAemContactFormId.FirstName]: { label: "First name", required: true, value: "" },
    [TradeInAemContactFormId.FirstLastName]: { label: "First last name", required: true, value: "" },
    [TradeInAemContactFormId.SecondLastName]: { label: "Second last name", required: true, value: "" },
    [TradeInAemContactFormId.Address]: { label: "Address", required: true, value: "" },
    [TradeInAemContactFormId.HouseNumber]: { label: "House number", required: true, value: "" },
    [TradeInAemContactFormId.PostalCode]: { label: "Postal code", required: true, value: "" },
    [TradeInAemContactFormId.City]: { label: "City", required: true, value: "" },
    [TradeInAemContactFormId.Email]: { label: "Email", required: true, value: "" },
    [TradeInAemContactFormId.Phone]: { label: "Phone", required: true, value: "" },
    [TradeInAemContactFormId.PrivacyDisclaimers]: {
        visualization: "checkbox",
        items: [
            { value: "disclaimer", label: "Disclaimer", selected: false, required: true },
            {
                value: "disclaimer-url",
                label: "Disclaimer with [link]url[/link]",
                selected: false,
                required: true,
                url: "http://www.google.com",
            },
        ],
    },
};
